import { LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import Section from '@/app/components/LegacyLandingPage/components/Section';

import CareersPhotoWall from './CareersPhotoWall';

const CareersTestimonials = () => {
  const t = useTranslations();

  return (
    <Section padTop data-cy="careers-testimonials">
      <LayoutGrid>
        <TypographyV3
          Element="h3"
          variant="h3"
          weight="light"
          className={cx(
            'col-main lg:col-start-13 lg:col-end-main',
            'mb-8 lg:mb-24',
          )}
        >
          {t('your_potential_realized')}
        </TypographyV3>
      </LayoutGrid>
      <CareersPhotoWall
        photos={[
          {
            src: 'careers/desktop_employee-highlight-avonte',
            alt: 'Avonte Campinha-Bacote',
            caption: {
              name: 'Avonte Campinha-Bacote',
              quote: 'avonte_quote',
              title: 'avonte_cb_job_title',
            },
          },
          {
            src: 'careers/desktop_employee-highlight-heli',
            alt: 'Heli Koskimäki',
            caption: {
              name: 'Heli Koskimäki',
              quote: 'heli_quote',
              title: 'heli_k_job_title',
            },
          },
          {
            src: 'careers/desktop_employee-highlight-wagner',
            alt: 'Wagner Borba',
            caption: {
              name: 'Wagner Borba',
              quote: 'wagner_quote',
              title: 'wagner_b_job_title',
            },
          },
        ]}
      >
        <TypographyV3>{t('empowering_our_community')}</TypographyV3>
      </CareersPhotoWall>
    </Section>
  );
};

export default CareersTestimonials;
